import { TableColumnModel } from '../tableColumsModel';
const SubscriptionId = new TableColumnModel('id', 'Id', 170, true, false);
const SubscriptionCustomer = new TableColumnModel('customer', 'Customer', 170, true, false);
const SubscriptionEventSource = new TableColumnModel('eventSource', 'Event Source', 170, true, false);
const SubscriptionActions = new TableColumnModel('actions', '', 170, false, true);

export const SubscriptionsTableColumns = () => {
  return [SubscriptionId, SubscriptionCustomer, SubscriptionEventSource, SubscriptionActions];
};
